var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u79FB\\u52A8\\u7AEF\\u63A8\\u5E7F\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u641C\\u7D22\\u7B80\\u5386",
    transform: "translate(-338.000000, -378.000000)",
    fill: "#9E9E9E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(0.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(188.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u641C\\u7D22\\u6A21\\u677F",
    transform: "translate(150.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03556883,10.64242 C5.3812805,11.9889537 7.40914108,12.3848934 9.16252853,11.6434589 C9.57941947,11.4671738 9.96810397,11.2305081 10.3160945,10.9410654 L12.575802,13.2020546 C12.6589564,13.2853083 12.7721669,13.3315167 12.8898282,13.3302548 C13.0075514,13.3305703 13.1205515,13.2839562 13.2037947,13.200713 C13.2870379,13.1174698 13.333652,13.0044698 13.333322,12.8867466 C13.334166,12.7691681 13.2880232,12.6561181 13.2051363,12.5727203 L10.9415836,10.3142946 C12.048628,8.97044653 12.3173057,7.12279325 11.6388501,5.51930552 C10.63303,3.14571537 7.89586352,2.03399234 5.51982367,3.0340118 C3.78937803,3.76462844 2.66518731,5.46101506 2.66666863,7.33937621 C2.66553311,8.57862791 3.15814979,9.76727322 4.03556883,10.64242 L4.03556883,10.64242 Z M3.55491636,7.33937621 C3.55562419,5.24915758 5.25052987,3.5552082 7.34074857,3.55567994 C9.43096727,3.55615189 11.125108,5.25086631 11.1248721,7.34108505 C11.1246363,9.43130379 9.43011312,11.125636 7.33989437,11.125636 C5.24959452,11.1242213 3.55562327,9.42967642 3.55491636,7.33937621 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray);
export default __webpack_public_path__ + "static/media/search-gray.084a85704daf5381065e5ceb7ebc4791.svg";
export { ForwardRef as ReactComponent };